export default {
    'SETTINGS.USER.EDIT.POPUP.TITLE': 'Edit user',
    'SETTINGS.USER.ADD.POPUP.TITLE': 'Add a new user',
    'SETTINGS.POPUP.SUCCESS.TITLE': 'Success',
    'SETTINGS.POPUP.SUCCESS.SUB': 'Account date updated',
};
